import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { APP_INITIALIZER, ApplicationConfig, importProvidersFrom, provideZoneChangeDetection } from '@angular/core';
import { provideRouter } from '@angular/router';
import { NgxSmartModalModule } from 'ngx-smart-modal';

import { provideEnvironmentNgxMask } from 'ngx-mask';
import { routes } from './app.routes';
import { jwtHttpInterceptor } from './interceptors/jwt-http.interceptor';
import { provideToastr } from 'ngx-toastr';
import { provideAnimations } from '@angular/platform-browser/animations';
import { EventService } from './domain/services/event.service';

// Factory function to initialize EventService on app startup
export function initializeEventService(eventService: EventService) {
  return () => {
    // EventService is already initialized via constructor
    // This just ensures it's instantiated at app startup
    return Promise.resolve();
  };
}

export const appConfig: ApplicationConfig = {
  providers: [
    provideZoneChangeDetection({ eventCoalescing: true }), 
    provideRouter(routes),
    importProvidersFrom(NgxSmartModalModule.forRoot()),
    provideHttpClient(
      withInterceptors([jwtHttpInterceptor])
    ),
    provideEnvironmentNgxMask(),
    provideAnimations(),
    provideToastr({
      preventDuplicates: true,
      positionClass: 'toast-top-full-width'
    }),
    {
      provide: APP_INITIALIZER,
      useFactory: initializeEventService,
      deps: [EventService],
      multi: true
    }
  ]
};
